/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebUrlModel } from '../../models/web-url-model';

export interface SaveWebUrl$Params {
      body?: WebUrlModel
}

export function SaveWebUrl(http: HttpClient, rootUrl: string, params?: SaveWebUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<WebUrlModel>> {
  const rb = new RequestBuilder(rootUrl, SaveWebUrl.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebUrlModel>;
    })
  );
}

SaveWebUrl.PATH = '/api/Developer/SaveWebUrl';
